export default __webpack_public_path__ + "static/media/elalbergue4.6e7ac4dd.jpg";